import {UI} from "../../../stem-core/src/ui/UIBase";

import {styleRule, styleRuleInherit} from "../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {Messages} from "../../Messages";
import {iFrameState} from "../../services/IFrameState";
import {merchantStyleRule} from "../Security";
import {DONATE_PAGE_URLS} from "../PanelConstants";
import {Switcher} from "../../../stem-core/src/ui/Switcher";
import {DonatePanel} from "./DonatePanel.jsx";
import {InlineAuthPanel} from "./InlineAuthPanel.jsx";
import {PayWithAddedCardPanel} from "./PayWithAddedCardPanel.jsx";
import {ThankYouPanel} from "./ThankYouPanel.jsx";
import {isSmallScreen} from "../../UtilsLib";
import {iFrameConnection} from "../../services/IFrameConnection";
import {IFrameMessages} from "../../../blink-sdk/messaging/IFrameMessages";
import {ThankYouMessageReceivedPanel} from "./ThankYouMessageReceivedPanel.jsx";
import {RecurringDonorPanel} from "./RecurringDonorPanel.jsx";
import {PayWithChosenCardPanel} from "./PayWithChosenCardPanel.jsx";
import {EditDonationPanel} from "./EditDonationPanel.jsx";
import {DonationUpdatedPanel} from "./DonationUpdatedPanel.jsx";
import {EditChooseCardPanel} from "./EditChooseCardPanel.jsx";
import {EditAddCardPanel} from "./EditAddCardPanel.jsx";
import {DonationCanceledPanel} from "./DonationCanceledPanel.jsx";
import {PaymentFailedPanel} from "./PaymentFailedPanel.jsx";
import {CancelDonationPanel} from "../pages/panels/donation/edit-donation/CancelDonationPanel.jsx";
import {iFrameMerchantService} from "../../services/IframeMerchantService";
import {iFrameUserDataService} from "../../services/IFrameUserDataService";
import {BasePanelPage, BasePanelPageStyle} from "../PanelPage.jsx";


class DonateHomePageStyle extends BasePanelPageStyle {
    @styleRuleInherit
    panelPage = {
        width: "100%",
    };

    @styleRule
    title = {
        textAlign: () => isSmallScreen() ? "" : "center",
        fontSize: () => isSmallScreen() ? 24 : 30,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
        marginBottom: () => isSmallScreen() ? 10 : 58,
    };

    @styleRule
    container = {
        display: "flex",
        justifyContent: "center",
        flexDirection: () => isSmallScreen() ? "column" : "row"
    };

    @merchantStyleRule
    paragraph = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE,
        marginBottom: "24px",
        maxWidth: "410px",
        ...iFrameState.textStyle
    };

    @styleRule
    switcher = {
        height: "fit-content",
        width: 430,
        maxWidth: "100%",
        marginBottom: 20,
        marginRight: () => isSmallScreen() ? 0 : 50,
        padding: () => isSmallScreen() ? "20px" : "30px 40px",
        border: () => "1px solid " + this.themeProps.MERCHANT_RADIO_BUTTON_SECONDARY_BORDER_COLOR,
    };
}

@registerStyle(DonateHomePageStyle)
export class DonateHomePage extends BasePanelPage {
    getDefaultOptions(options) {
        return {
            ...super.getDefaultOptions(options),
            withPanelFrame: false,
        }
    }

    render() {
        const {styleSheet} = this;
        const changeURL = this.changeURL.bind(this);
        const publicationName = iFrameMerchantService.getMerchant().name;
        const title = iFrameState.title || Messages.donatePageTitle(publicationName);
        const text = iFrameState.panelText || "";
        const switcherStyle = text ? {} : {
            marginBottom: 0,
            marginRight: 0,
        }

        return [
            title && <div className={styleSheet.title}>{title}</div>,
            <div className={styleSheet.container}>
                <Switcher lazyRender ref="switcher" className={styleSheet.switcher} style={switcherStyle}>
                    <DonatePanel changeURL={changeURL} ref={DONATE_PAGE_URLS.donate}/>
                    <RecurringDonorPanel changeURL={changeURL} ref={DONATE_PAGE_URLS.recurringDonor}/>
                    <EditDonationPanel changeURL={changeURL} ref={DONATE_PAGE_URLS.editDonation}/>
                    <InlineAuthPanel changeURL={changeURL} ref={DONATE_PAGE_URLS.auth}/>
                    <PayWithAddedCardPanel changeURL={changeURL} ref={DONATE_PAGE_URLS.payWithAddedCard}/>
                    <PayWithChosenCardPanel changeURL={changeURL} ref={DONATE_PAGE_URLS.payWithChosenCard}/>
                    <ThankYouPanel changeURL={changeURL} ref={DONATE_PAGE_URLS.thankYou}/>
                    <ThankYouMessageReceivedPanel changeURL={changeURL} ref={DONATE_PAGE_URLS.thankYouMessageReceived}/>
                    <DonationUpdatedPanel changeURL={changeURL} ref={DONATE_PAGE_URLS.donationUpdated}/>
                    <EditChooseCardPanel changeURL={changeURL} ref={DONATE_PAGE_URLS.editChooseCard}/>
                    <EditAddCardPanel changeURL={changeURL} ref={DONATE_PAGE_URLS.editAddCard}/>
                    <CancelDonationPanel
                        ref={DONATE_PAGE_URLS.cancelDonation}
                        withPanelFrame={false}
                        onAction={() => changeURL(DONATE_PAGE_URLS.donationCanceled)}
                        onBack={() => changeURL(DONATE_PAGE_URLS.editDonation)}
                        notCentered={true}
                    />
                    <DonationCanceledPanel
                        changeURL={changeURL}
                        ref={DONATE_PAGE_URLS.donationCanceled}/>
                    <PaymentFailedPanel changeURL={changeURL} ref={DONATE_PAGE_URLS.paymentFailed}/>
                </Switcher>
                <div>{text.split("\n").map(paragraph =>
                    <div className={styleSheet.paragraph}>{paragraph}</div>)}
                </div>
            </div>
        ];
    }

    changeURL(url, forceRedraw=false) {
        this.switcher.setActive(this[url]);
        if (isSmallScreen()) {
            iFrameConnection.sendToSDK(IFrameMessages.SCROLL_IFRAME_TOP);
        }
        if (forceRedraw) {
            this.redraw();
        }
    };

    onMount() {
        super.onMount();

        if (iFrameUserDataService.getActiveRecurringDonation()) {
            this.changeURL(DONATE_PAGE_URLS.recurringDonor, true);
        }
    }
}
